import { GridCellProps } from '@progress/kendo-react-grid';
import { SHToolTip } from 'app/components/SHToolTip';
import styled from 'styled-components';

type Props = {
  className?: string;
  e: GridCellProps;
};

const UserNameCell = ({ className, e }: Props) => {
  const data = e.dataItem;
  return (
    <td style={e.style} className={e.className}>
      <SHToolTip position="top">
        <NameWrapper title={data?.email}>{data?.email}</NameWrapper>
      </SHToolTip>
    </td>
  );
};

export default UserNameCell;
const NameWrapper = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  min-width: 150px;
  max-width: 200px;
  color: #475467;
`;
